import React from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames/bind';
import { Button, Col, Row } from 'antd';
import { useNavigate } from 'react-router-dom';
import LoadingView from '~/components/Loading';
import Content from '~/layouts/Content';
import PATH from '~/constants/path';
import Table from '~/components/Common/Table';
import styles from './index.module.scss';
import { columns } from './columns';
import { FilterListQuestionnaire } from './filter';

type ListQuestionnaireViewProps = {
  isCompany: boolean;
  setFilters: (filters: any) => void;
  handleChangePage: (page: number) => void;
  handleSort: (sort: any) => void;
  dataSource: any;
  isQuestionnaireScreen: boolean;
  pagination: any;
  handleDeleteQuestionnaire: (id: string) => void;
  handleExportQuestionnaire?: (id: string) => void;
  loading: boolean;
  filters: any;
};

const ListQuestionnaireView = ({
  isCompany,
  setFilters,
  handleChangePage,
  handleSort,
  dataSource,
  isQuestionnaireScreen,
  pagination,
  handleDeleteQuestionnaire,
  handleExportQuestionnaire,
  loading,
  filters,
}: ListQuestionnaireViewProps): React.ReactElement => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const cx = classNames.bind(styles);

  const handleTableChange = (_, filterCol, sort): void => {
    const { columnKey, field, order } = sort;

    if (
      Object.keys(filterCol).length !== 0 &&
      filterCol.constructor === Object
    ) {
      setFilters?.({
        ...filters,
        status: Array.isArray(filterCol.status)
          ? {
              in: filterCol.status,
            }
          : undefined,
      });
    }
    if (!order) {
      handleSort?.({ columnKey: 'createdAt', order: 'descend' });
    } else {
      handleSort?.({ columnKey, field, order });
    }
  };

  return (
    <>
      <LoadingView loading={loading} />
      <Content
        title={
          isQuestionnaireScreen
            ? t('questionnaire.list.pageTitle')!
            : t('healthCheck.list.title')
        }
      >
        <div className={cx('wrapper')}>
          <FilterListQuestionnaire
            setFilters={setFilters}
            isQuestionnaireScreen={isQuestionnaireScreen}
          />
          <div className={cx('table-wrapper')}>
            <Row>
              <Col
                className={cx('btn-create')}
                lg={{ span: 3, offset: 21 }}
                sm={{ span: 8, offset: 16 }}
              >
                <Button
                  type="primary"
                  onClick={(): void =>
                    navigate(
                      isQuestionnaireScreen
                        ? PATH[isCompany ? 'company' : 'system'].questionnaire
                            .create
                        : PATH[isCompany ? 'company' : 'system'].healthCheck
                            .create,
                    )
                  }
                >
                  {t('questionnaire.list.create')}
                </Button>
              </Col>
            </Row>
            <Table
              columns={columns({
                isCompany,
                isQuestionnaireScreen,
                handleDeleteQuestionnaire,
                handleExportQuestionnaire,
              })}
              dataSource={dataSource || []}
              rowKey="id"
              pagination={{
                current: pagination?.currentPage,
                total: pagination?.total,
                onChange: handleChangePage,
                pageSize: pagination?.perPage,
                position: ['bottomCenter'],
              }}
              className={cx('table')}
              scroll={{ x: true }}
              onChange={handleTableChange}
            />
          </div>
        </div>
      </Content>
    </>
  );
};
export default ListQuestionnaireView;
